// Utility to normalize candidate data to UI formData and back to API payload

export const toFormData = (candidateData = {}, config) => {
  const c = candidateData || {};
  return {
    // Personal info
    firstName: c.first_name || c.firstName || '',
    fatherName: c.father_name || c.fatherName || '',
    lastName: c.last_name || c.lastName || '',
    birthDate: c.birth_date || c.birthDate || '',
    phone: c.phone || c.phone_number || '',
    email: c.email || c.email_address || '',
    nationalId: c.national_id || c.nationalId || '',
    // Address
    city: c.city || '',
    district: c.district || '',
    street: c.street || '',
    buildingNumber: c.building_number || c.buildingNumber || '',
    postalCode: c.postal_code || c.postalCode || '',
    // Work
    isCurrentlyEmployed: (c.is_currently_employed ?? c.isCurrentlyEmployed) || false,
    employer: c.employer || '',
    jobTitle: c.job_title || c.jobTitle || '',
    hasNonProfitExperience: (c.has_nonprofit_experience ?? c.hasNonProfitExperience) || false,
    nonProfitOrganization: c.nonprofit_organization || c.nonProfitOrganization || '',
    yearsOfExperience: c.years_of_experience || c.yearsOfExperience || '',
    // Nomination
    branch: (c.branch_id && typeof c.branch_id === 'string')
      ? c.branch_id
      : (c.branch?.id || c.branch?.code || ''),
    center: (c.center_id && typeof c.center_id === 'string')
      ? c.center_id
      : (c.center?.id || c.center?.code || ''),
    associationKnowledge: c.society_knowledge || c.associationKnowledge || '',
    socialResponsibility: c.social_responsibility_contribution || c.socialResponsibility || '',
    vision2030Programs: c.vision_2030_contribution || c.vision2030Programs || '',
    centerIncomeIdeas: c.center_income_ideas || c.centerIncomeIdeas || '',
    readRegulations: !!(c.regulations_acknowledgement ?? c.readRegulations),
    confirmResponsibilities: !!(c.commitment_acknowledgement ?? c.confirmResponsibilities),
    acceptTerms: !!(c.terms_and_conditions_acknowledgement ?? c.acceptTerms),
    // Documents (URLs only for display)
    personal_photo: c.personal_photo_url ? { url: c.personal_photo_url } : null,
    cv: c.cv_document_url ? { url: c.cv_document_url } : null,
    security_clearance: c.security_clearance_document_url ? { url: c.security_clearance_document_url } : null,
  };
};

export const toApiPayload = (formData = {}) => ({
  first_name: formData.firstName ?? '',
  father_name: formData.fatherName ?? '',
  last_name: formData.lastName ?? '',
  birth_date: formData.birthDate ?? null,
  phone: formData.phone ?? '',
  email: formData.email ?? '',
  national_id: formData.nationalId ?? '',
  city: formData.city ?? '',
  district: formData.district ?? '',
  street: formData.street ?? '',
  building_number: formData.buildingNumber ?? '',
  postal_code: formData.postalCode ?? '',
  is_currently_employed: !!formData.isCurrentlyEmployed,
  employer: formData.employer ?? '',
  job_title: formData.jobTitle ?? '',
  has_nonprofit_experience: !!formData.hasNonProfitExperience,
  nonprofit_organization: formData.nonProfitOrganization ?? '',
  years_of_experience: formData.yearsOfExperience ?? '',
  branch_id: formData.branch ?? '',
  center_id: formData.center ?? '',
  society_knowledge: formData.associationKnowledge ?? '',
  social_responsibility_contribution: formData.socialResponsibility ?? '',
  vision_2030_contribution: formData.vision2030Programs ?? '',
  center_income_ideas: formData.centerIncomeIdeas ?? '',
  regulations_acknowledgement: !!formData.readRegulations,
  commitment_acknowledgement: !!formData.confirmResponsibilities,
  terms_and_conditions_acknowledgement: !!formData.acceptTerms,
});
